<template>
  <v-row class="body">
    <v-col
      class="pa-13"
      align="center"
      cols="12"
      md="5"
      xl="3"
      lg="4"
      sm="12"
      xs="12"
    >
      <v-form @submit.prevent="verifyOTP()">
        <v-slide-y-transition>
          <v-card v-if="verifySuccess" flat class="card mt-5 pa-6">
            <div class="d-flex align-center justify-center ga-3">
              <span
                class="mdi mdi-check-decagram-outline"
                style="font-size: 40px; color: green"
              ></span>
              <h2 style="color: #14a44d; font-size: 16px">
                OTP verified successfully
              </h2>
            </div>
          </v-card>
        </v-slide-y-transition>
        <v-card v-if="!verifySuccess" flat class="card mt-5 pa-6">
          <img
            style="width: 6rem"
            class="mb-3"
            :src="require('../../public/logo.png')"
            alt=""
          />
          <div>
            <v-card-title align="center" class="Login-title pa-0 ma-0 pb-3"
              >Enter your OTP</v-card-title
            >
            <v-col class="pa-0 ma-0">
              <v-error
                align="start"
                v-if="errorMessage && this.otp"
                style="color: red; font-size: 14px"
                class="pa-0 ma-0"
                >{{ errorMessage }}</v-error
              >
            </v-col>
            <v-card-text class="pa-0 mt-2 pt-2">
              <v-col class="pa-0 ma-0">
                <v-col align="start" class="pa-0 ma-0 lable">OTP</v-col>
                <TextFieldComponent
                  @click:append-inner="showOtp = !showOtp"
                  :rules="otpRule"
                  v-model="otp"
                  variant="outlined"
                  @keyup.enter="verifyOTP()"
                  v-bind:type="[showOtp ? 'text' : 'password']"
                  :append-inner-icon="showOtp ? 'mdi-eye' : 'mdi-eye-off'"
                ></TextFieldComponent>
              </v-col>
            </v-card-text>
            <v-col align="start" class="pa-0 ma-0">
              <div
                v-if="this.timeLeft !== 0"
                style="font-size: 14px; color: gray"
              >
                OTP expire in:
                <span style="color: #0068b3">
                  {{ Math.floor(timeLeft / 60) }}:{{
                    ("0" + (timeLeft % 60)).slice(-2)
                  }}</span
                >
              </div>
              <div
                v-if="this.timeLeft == 0"
                style="font-size: 14px; color: red"
              >
                OTP has expired. Please request a new one.
              </div>
            </v-col>
            <v-col class="pa-0 ma-0" align="start">
              <v-btn
                align="start"
                variant="text"
                class="pa-0 ma-0 mb-4 mt-2 forget"
                @click="sendOtp()"
                >Resent OTP ?</v-btn
              ></v-col
            >
            <v-card-action>
              <v-col class="pa-0 pt-2" cols="12">
                <v-btn
                  color="#0068B3"
                  type="submit"
                  block
                  size="large"
                  :loading="loading"
                  class="text-none log-btn text-white mb-4"
                  >Verify</v-btn
                >
              </v-col>
            </v-card-action>
          </div>
        </v-card>

        <v-col class="log-text mt-4" v-if="!verifySuccess"
          >If you have trouble signing in please contact administrator</v-col
        >
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import userService from "../api/service/UserService.js";
import TextFieldComponent from "./TextFieldComponent.vue";
// import ResetPasswordService from "@/api/service/ResetPasswordService";

export default {
  components: {
    TextFieldComponent,
  },
  data() {
    return {
      token: null,
      error: null,
      userNotFount: false,
      loading: false,
      userName: null,
      showOtp: false,
      verifySuccess: false,
      errorMessage: null,
      sessionInfo: null,
      redirecturl: null,
      otpRule: [(value) => !!value || "OTP  is Required."],
      otp: null,
      host: "",
      timeLeft: 300,
      timer: null,
    };
  },
  async created() {
    await this.sendOtp();
  },
  watch: {
    otp(newVal) {
      if (newVal === "") {
        this.errorMessage = null;
      }
    },
  },
  mounted() {
    this.token = this.$route.query.token;
    this.userName = this.$route.query.email;
  },
  methods: {
    startTimer() {
      this.timeLeft = 300;
      if (this.timer) clearInterval(this.timer);

      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    async verifyOTP() {
      if (this.otp && this.userName) {
        try {
          this.loading = true;
          this.errorMessage = "";
          this.error = "";
          let response = await userService.verifyOTP({
            otp: this.otp,
            email: this.userName,
          });
          this.errorMessage = response.data.message;
          console.log(response, "ressss");
          if (response.data.message) {
            this.loading = false;
          }
          if (
            response.data.message == "OTP verified successfully" &&
            this.token
          ) {
            (this.verifySuccess = true),
              setTimeout(() => {
                try {
                  this.loading = false;
                  window.location =
                    localStorage.getItem("REDIRECT_URL") +
                    "?token=" +
                    this.token;
                  console.log(response, "1111");
                } catch (e) {
                  console.log(e, "error");
                }
              }, 2000);
          }
        } catch (e) {
          console.log(e, "error2");
          (this.error = e.message), (this.loading = false);
        }
      }
    },

    // async sendEmail() {
    //   try {
    //     this.loading = true;
    //     let data = {
    //       host: window.location.origin,
    //       email: this.email,
    //       appId: localStorage.getItem("APP_ID"),
    //       redirectUrl: localStorage.getItem("REDIRECT_URL"),
    //     };
    //     localStorage.setItem("PASSWORD_DATA", JSON.stringify(data));
    //     let response = await ResetPasswordService.forgotPassword(data);
    //     console.log(response, "hhhhhhhhh");
    //     if (response.message == "User not found in firebase") {
    //       this.userNotFount = true;
    //       this.loading = false;
    //     } else {
    //       this.$router.push({
    //         path: "/checkemail",
    //         query: { email: this.email, host: window.location.origin },
    //       });
    //     }
    //   } catch (e) {
    //     this.loading = false;
    //     console.log(e);
    //   }
    // },

    async sendOtp() {
      (this.otp = ""), (this.errorMessage = null);
      this.token = this.$route.query.token;
      this.userName = this.$route.query.email;
      if (this.token) {
        let response = await userService.fireBaseSend({ email: this.userName });
        // this.sessionInfo = response.data.token.sessionInfo;
        console.log(response);
      }
      this.startTimer();
    },
  },
};
</script>

<style>
.back {
  cursor: pointer;
}

.back:hover {
  color: rgb(104, 104, 246);
  cursor: pointer;
}
</style>
